import { FillerTherapist } from '@/screens/Filler/FillerTherapist';
import { FillerBody } from '@/components/FillerBody';
import { isTherapistApp } from '@/config/constants';

export const Filler = () => {
  if (isTherapistApp) {
    return <FillerTherapist />;
  }

  return <FillerBody />;
};
